import { useTranslation } from 'react-i18next';

/**
 * The "OR" separator between an auth screen's primary form and its
 * alternative actions (social login, one-time code).
 */
const AuthDivider = ({ newDesign = false }: { newDesign?: boolean }) => {
  const { t } = useTranslation();

  return (
    <div className={newDesign ? 'flex items-center gap-3' : 'relative'}>
      {newDesign && <div className="h-px flex-1 bg-gray-200" />}
      <div className="relative flex justify-center">
        <span
          className={
            newDesign
              ? 'bg-white px-2 text-sm text-gray-500 tracking-wide md:text-base'
              : 'text-body-medium-regular bg-white px-2 text-gray-500 uppercase tracking-wide'
          }
        >
          {newDesign ? (
            <>
              <span className="hidden uppercase md:inline">{t('OR')}</span>
              <span className="md:hidden">{t('or continue with')}</span>
            </>
          ) : (
            t('OR')
          )}
        </span>
      </div>
      {newDesign && <div className="h-px flex-1 bg-gray-200" />}
    </div>
  );
};

export default AuthDivider;
